import { useMutation, useQueryClient } from '@tanstack/react-query';
import { channelsApi } from '../services';

export const useRemoveUserFromChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ channelId, userId }: { channelId: string; userId: string }) =>
      channelsApi.removeUserFromChannel(channelId, userId),

    onSuccess: (_, variables) => {
      // Invalidate channels list (usado em ChannelsPage - listagem com members)
      queryClient.invalidateQueries({ queryKey: ['channels'] });
      // Invalidate channel users list
      queryClient.invalidateQueries({ queryKey: ['channel-users', variables.channelId] });
      // Invalidate available users
      queryClient.invalidateQueries({ queryKey: ['available-users', variables.channelId] });
      // Invalidate operators stats
      queryClient.invalidateQueries({ queryKey: ['channel-operators-stats', variables.channelId] });
      // Invalidate channel operators (usado em OperatorsSection e LotteryConfigSection)
      queryClient.invalidateQueries({ queryKey: ['channel-operators', variables.channelId] });
    }
  });
};
